// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"AddCartForm_wrapperComponent__uO9iP","actions":"AddCartForm_actions__B90AV"};